module.exports = __webpack_public_path__ + "static/media/curbToCurbIcon.0ededd35.svg";